import $ from "jquery";

function init(): void {
  // Special field added via input hidden with specified value
  const $inputUrl = $("input[value=URL_Reference]");

  if ($inputUrl.length) {
    // Replace value of the field with current URL
    const url = window.location.href;
    $inputUrl.val(url);
  }
}

export default { init };
